module.exports = __webpack_public_path__ + "static/img/8.97e10df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/8.png
// module id = D636
// module chunks = 0